import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const TermsOfService: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h3" gutterBottom align="center">
        Terms of Service
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        sx={{ mb: 4 }}
      >
        Last updated: November 4, 2025
      </Typography>

      <Divider sx={{ mb: 4 }} />

      <Box sx={{ "& > *": { mb: 3 } }}>
        <section>
          <Typography variant="h5" gutterBottom>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing and using InkBowl, you accept and agree to be bound by
            the terms and provision of this agreement.
          </Typography>
        </section>

        <section>
          <Typography variant="h5" gutterBottom>
            2. Age Requirements
          </Typography>
          <Typography variant="body1" paragraph>
            You must be at least 16 years old to use InkBowl. By using our
            service, you represent and warrant that you meet this age
            requirement.
          </Typography>
        </section>

        <section>
          <Typography variant="h5" gutterBottom>
            3. Geographic Restrictions
          </Typography>
          <Typography variant="body1" paragraph>
            InkBowl is currently available to residents of the United States,
            United Kingdom, European Union, and Canada. Use from other regions
            is not permitted.
          </Typography>
        </section>

        <section>
          <Typography variant="h5" gutterBottom>
            4. User Content
          </Typography>
          <Typography variant="body1" paragraph>
            You retain ownership of content you submit to InkBowl. However, by
            submitting content, you grant us a license to use, display, and
            distribute your content on our platform.
          </Typography>
        </section>

        <section>
          <Typography variant="h5" gutterBottom>
            5. Prohibited Conduct
          </Typography>
          <Typography variant="body1" paragraph>
            You agree not to use InkBowl for any unlawful purpose or in any way
            that could damage, disable, or impair our service.
          </Typography>
        </section>

        <section>
          <Typography variant="h5" gutterBottom>
            6. Account Termination
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to terminate or suspend your account at any
            time for violations of these terms.
          </Typography>
        </section>

        <section>
          <Typography variant="h5" gutterBottom>
            7. Contact Information
          </Typography>
          <Typography variant="body1">
            For questions about these Terms of Service, contact us at
            legal@inkbowl.com
          </Typography>
        </section>
      </Box>
    </Container>
  );
};

export default TermsOfService;
